import store from '../store'
import EventSystem from '../helpers/EventSystem'
class API {
  constructor () {
    this.active = []
    this.state = store.getState().siteReducer
    store.subscribe(() => {
      this.state = store.getState().siteReducer
    })
  }
  debug (values) {
    if (process.env.REACT_APP_DISABLE_RPC_LOGGING) return
    console.log(...values)
  }
  async _make (endpoint, query, wrapper, suppressError) {
    var start = Date.now()
    this.active[`${start}_${endpoint}`] = true
    EventSystem.publish('show_rpc_loader', {})
    return new Promise((resolve, reject) => {
      this.state.deepstream.rpc.make(endpoint, { ...query, token: this.state.token, origin: 'FLOW-GUI' }, (error, response) => {
        var now = Date.now()
        this.debug('')
        this.debug(['%c Firing RPC ' + endpoint + '', 'background: #222; color: #bada55'])
        this.debug(['Query: ', query])
        this.debug(['Start: ', start, 'Now: ', now, 'Time: ', now - start, 'ms'])
        if (this.state.developer) {
          EventSystem.publish('api_rpc_call', { endpoint: endpoint, query: query, response: response, time: now - start, start: start, end: now, error: error })
        }
        if (error && !suppressError && this.state.developer) {
          this.debug(['ERROR'])
          this.debug([error])
          this.debug([endpoint, error, query])
          delete this.active[`${start}_${endpoint}`]
          if (!Object.keys(this.active).length) EventSystem.publish('hide_rpc_loader', {})
          store.dispatch({
            type: 'ALERT_CREATE',
            payload: {
              title: error,
              type: 'error',
              text: 'The server is currently unavailable, try again later. \b' + 'ENDPOINT:' + endpoint
            }
          })
          return reject(error)
        }
        if (response && response.count) this.debug(['Count: ', response.count])
        this.debug(['RESPONSE: ', response])
        this.debug([''])
        delete this.active[`${start}_${endpoint}`]
        if (!Object.keys(this.active).length) EventSystem.publish('hide_rpc_loader', {})
        if (wrapper) resolve({ ...wrapper, ...response })
        resolve(response)
      })
    })
  }
  async make (endpoint, query, wrapper, suppressError) {
    query = query || {}

    if (query.data && query.data.attributes) {
      var attributes = Object.assign({}, query.data.attributes)
      let entries = Object.entries(attributes)
      for (let i = 0; i < entries.length; i++) {
        if (attributes[entries[i][0]] && attributes[entries[i][0]].hasOwnProperty('value') && (attributes[entries[i][0]].value !== true && attributes[entries[i][0]].value !== false && !attributes[entries[i][0]].value.length) && !attributes[entries[i][0]].writeEmpty) {
          delete attributes[entries[i][0]]
        } else if (attributes[entries[i][0]] && attributes[entries[i][0]].hasOwnProperty('value')) {
          attributes[entries[i][0]] = attributes[entries[i][0]].value
        }
      }
      return this._make(endpoint, query, wrapper, suppressError)
    }
    return this._make(endpoint, query, wrapper, suppressError)
  }
  update (endpoint, query, suppressError) {
    return this.make(endpoint, { method: 'UPDATE', ...query }, null, suppressError)
  }
  open (endpoint, query, suppressError) {
    if (typeof query === 'string') return this.make(endpoint, { method: 'OPEN', objectid: query }, null, suppressError)
    return this.make(endpoint, { method: 'OPEN', ...query }, null, suppressError)
  }
  list (endpoint, query, suppressError) {
    return this.make(endpoint, { method: 'LIST', ...query }, null, suppressError)
  }
  create (endpoint, query, suppressError) {
    return this.make(endpoint, { method: 'CREATE', ...query }, null, suppressError)
  }
  delete (endpoint, query, suppressError) {
    return this.make(endpoint, { method: 'DELETE', ...query }, null, suppressError)
  }
  index (endpoint, query, suppressError) {
    return this.make(endpoint, { method: 'INDEX', ...query }, null, suppressError)
  }
  run (endpoint, query, suppressError) {
    return this.make(endpoint, { method: 'RUN', ...query }, null, suppressError)
  }
  multi (requests) {
    return Promise.all(requests)
  }
  dispatch (object) {
    Object.keys(object).map(key => {
      store.dispatch({
        type: key,
        payload: object[key]
      })
    })
  }
}
export default new API()



// WEBPACK FOOTER //
// ./src/API/index.js